<form class="vtr-ui-custom-switch">
	<div *ngIf="isLoading"
		class="row">
		<vtr-spinner></vtr-spinner>
	</div>
	<div class="form-group">
		<div class="custom-control custom-switch"
			[hidden]="isLoading">
			<input type="checkbox"
				class="custom-control-input"
				role="switch"
				tabindex="0"
				[id]="componentId + '_checkbox'"
				[disabled]="isDisabled"
				[checked]="value"
				[value]="value"
				[attr.aria-label]="ariaLabel"
				[attr.aria-disabled]="isDisabled"
				[attr.aria-checked]="value"
				(change)="onChange($event)">
			<label class="custom-control-label"
				[for]="componentId + '_checkbox'">
				{{label}}
			</label>
		</div>
	</div>
</form>
